import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SEOSchema from '@/components/feature/SEOSchema';
import HeroSection from './components/HeroSection';
import FeaturedComics from './components/FeaturedComics';
import CategorySection from './components/CategorySection';
import LatestUpdates from './components/LatestUpdates';
import FAQSection from './components/FAQSection';

export default function Home() {
  return (
    <>
      <SEOSchema type="home" />
      <Navbar />
      <main>
        <HeroSection />
        <FeaturedComics />
        <CategorySection />
        <LatestUpdates />
        <FAQSection />
      </main>
      <Footer />
      <ScrollToTop />
    </>
  );
}